export default __webpack_public_path__ + "static/media/330_store01-en-mobile.857a59d2.png";